import { useState } from 'react';

import AccountDetails from '../../components/accounts/account-details/account-details.component';
import AppConfigurationDisplay from '../../components/configuration/sections/app/app-configuration-display.component';
import DataConfigurationDisplay from '../../components/configuration/sections/data/data-configuration-display.component';
import GeneralConfigurationDisplay from '../../components/configuration/sections/general/general-configuration-display.component';
import LegalConfigurationDisplay from '../../components/configuration/sections/legal/legal-configuration-display.component';
import ShopConfigurationDisplay from '../../components/configuration/sections/shop/shop-configuration-display.component';

import {
  ConfigurationTitle,
  ContentContainer,
  MainContainer,
  TabContainer,
  TabButton,
  TabList,
  TabPanel
} from './configuration.styles';

const tabs = [
  { id: 'general', label: 'General' },
  { id: 'app', label: 'App' },
  { id: 'shop', label: 'Shop' },
  { id: 'legal', label: 'Legal' },
  { id: 'account', label: 'Account' },
  { id: 'data', label: 'Data' },
  // { id: 'analytics', label: 'Analytics' },
  // { id: 'support', label: 'Support' },
  // { id: 'crypto', label: 'Crypto' },
  // { id: 'fulfillment', label: 'Fulfillment' },
  // { id: 'restrictions', label: 'Restrictions' },
];

const ConfigurationPage = () => {
  const [currentTab, setCurrentTab] = useState('general');

  const renderPanelContent = () => {
    switch (currentTab) {
      case 'account':
        return <AccountDetails />;
      case 'data':
        return <DataConfigurationDisplay />;
      case 'app':
        return <AppConfigurationDisplay />;
      case 'general':
        return <GeneralConfigurationDisplay />;
      case 'legal':
        return <LegalConfigurationDisplay />;
      case 'shop':
        return <ShopConfigurationDisplay />;
      default:
        return <div style={{ padding: '2rem' }}>Coming Soon</div>;
    }
  };

  return (
    <MainContainer>
      <ConfigurationTitle>App Configuration</ConfigurationTitle>

      <TabContainer>
        <TabList>
          {tabs.map(tab => (
            <TabButton
              key={tab.id}
              active={currentTab === tab.id}
              onClick={() => setCurrentTab(tab.id)}
            >
              {tab.label}
            </TabButton>
          ))}
        </TabList>
      </TabContainer>

      <ContentContainer>
        <TabPanel>
          {renderPanelContent()}
        </TabPanel>
      </ContentContainer>
    </MainContainer>
  );
};

export default ConfigurationPage;